module.exports = __webpack_public_path__ + "img/market2.cbad6bc5.jpg";